export const RECEIVE_EXTERNAL_LINKS = 'app/root/RECEIVE_EXTERNAL_LINKS';
